<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Personal layer</h2>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="personalLayerForm" (ngSubmit)="submitFormPersonalLayer()">
    <mat-dialog-content>
      <div class="fields-line-1">
        <mat-form-field class="field-grow">
          <mat-label>File</mat-label>
          <button
            matIconButton
            matPrefix
            type="button"
            aria-label="Upload file"
            [disabled]="uploadToEdit.id"
            (click)="hiddenInput.click()"
          >
            <mat-icon>upload_file</mat-icon>
          </button>
          <input
            hidden
            type="file"
            accept=".tif,.csv,.geojson"
            #hiddenInput
            (change)="getFileOnLoad($event)"
          />
          <input
            matInput
            [value]="this.fileName"
            readonly
            disabled
            type="text"
            id="fakeFileInputPersonalLayer"
            (click)="hiddenInput.click()"
          />
        </mat-form-field>

        <mat-form-field class="field-grow">
          <mat-label for="layer-type">Select the layer type</mat-label>
          <mat-select formControlName="type">
            <mat-option value="Geojson">Geojson</mat-option>
            @for (group of groupedLayers$(); track group) {
              <mat-optgroup [label]="group.category">
                <ng-container>
                  @for (layer of group.layers; track layer) {
                    <mat-option [value]="layer.name">
                      {{ layer.name }}
                    </mat-option>
                  }
                </ng-container>
              </mat-optgroup>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if (geojsonError) {
        <p class="local-warning">{{ geojsonError }}</p>
      }

      <mat-form-field subscriptSizing="dynamic" class="share-field">
        <mat-label>Share</mat-label>
        <input
          matInput
          formControlName="emails"
          [matTooltip]="emailListTooltipMessage()"
          matTooltipPosition="above"
          placeholder="jane.doe@example.com; john.doe@example.com"
        />
        <mat-hint>Separate the email addresses with a semicolon <b>' ; '</b></mat-hint>
        <ng-container>
          @if (personalLayerForm.get('emails')?.invalid) {
            <mat-error>Please enter valid email addresses</mat-error>
          }
        </ng-container>
      </mat-form-field>

      @if (devOrLocalhost.getValue() == 'Localhost') {
        <p class="local-warning">
          Personal layers are linked to the connected API at the time of upload. You will not be
          able to load or delete data uploaded locally (when using docker-compose-local.yml) on
          citiwattsdev or vice versa. Send an email
          <a href="mailto:citiwatts@hevs.ch">citiwatts&#64;hevs.ch</a> for more information.
        </p>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      @if (isUploading) {
        <mat-icon><mat-spinner diameter="20"></mat-spinner></mat-icon>
      }
      <button
        matButton
        matButton="outlined"
        type="button"
        class="warn-button"
        [disabled]="isUploading"
        (click)="cancel()"
      >
        Cancel
      </button>
      <button
        matButton="filled"
        type="submit"
        [disabled]="!personalLayerForm.valid || isUploading || !!geojsonError"
      >
        <ng-container>
          @if (uploadToEdit.id) {
            Update layer
          } @else {
            Upload layer
          }
        </ng-container>
      </button>
    </mat-dialog-actions>
  </form>
</div>
